import {
  UPDATE_BASIC_PICKUP_TIME_AND_DELAY,
  UPDATE_FROM,
  UPDATE_PICKUP_DELAY,
  UPDATEBASICPICKUPTIME,
  UPDATEBRANCHDELAYTIME,
  UPDATE_MANUAL_PICKUP_TIME_SETUP,
} from '../actions/pickupTimeAction';

const INITIAL_STATE = {
  pickupTimeInfo: {
    basicPickupTime: 0,
    delayPickupTime: 0,
    deliveryEnabled: true,
    addrUpdateEnabled: false,
    updateFromServer: false,
    manualPickupTimeSetup: false,
  },
};

const pickupTimeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATEBASICPICKUPTIME:
      return {
        pickupTimeInfo: {
          ...state.pickupTimeInfo,
          basicPickupTime: Number(action.basicPickupTime),
        },
      };
    case UPDATE_PICKUP_DELAY:
      return {
        pickupTimeInfo: {
          ...state.pickupTimeInfo,
          delayPickupTime: Number(action.pickupDelay),
        },
      };
    case UPDATE_BASIC_PICKUP_TIME_AND_DELAY:
      const {
        pickupDelay,
        basicPickupTime,
        deliveryEnabled,
        addrUpdateEnabled,
        updateFromServer,
      } = action.payload;
      return {
        pickupTimeInfo: {
          ...state.pickupTimeInfo,
          basicPickupTime: Number(basicPickupTime),
          delayPickupTime: Number(pickupDelay),
          deliveryEnabled: deliveryEnabled,
          addrUpdateEnabled: addrUpdateEnabled,
          updateFromServer: updateFromServer,
        },
      };
    case UPDATE_FROM:
      return {
        pickupTimeInfo: {
          ...state.pickupTimeInfo,
          updateFromServer: action.payload,
        },
      };
    case UPDATE_MANUAL_PICKUP_TIME_SETUP:
      return {
        pickupTimeInfo: {
          ...state.pickupTimeInfo,
          manualPickupTimeSetup: action.payload,
        },
      };
    case UPDATEBRANCHDELAYTIME:
      const branchInfo = Object.assign({}, state.pickupTimeInfo, {
        ...action.delayData,
      });
      return Object.assign({}, state, {
        pickupTimeInfo: { ...branchInfo, updateFromServer: true },
      });

    default:
      return state;
  }
};

export default pickupTimeReducer;
